// @flow

import React from 'react'
import { Subscribe } from 'unstated'
import VisaPlusProfileState from '../state'

type Props = {
  childProps: {
    body: React$Element,
  },
}

class VisaPlusProfileStateContainer extends React.Component<Props> {
  render() {
    const { childProps } = this.props
    return React.cloneElement(childProps.body, { ...this.props })
  }
}

export default (props: Props) => (
  <Subscribe to={[VisaPlusProfileState]}>
    {visaPlusProfileState => (
      <VisaPlusProfileStateContainer
        visaPlusProfileState={visaPlusProfileState}
        childProps={props}
      />
    )}
  </Subscribe>
)
